import DataAdapter from 'rise-ui/adapters/apis/rise-api/data.js';

import modelReport from 'rise-ui/utils/model-report.js';

@modelReport('route/time-series')
export default class LocationAdapter extends DataAdapter {}
